import React,{createRef, forwardRef,useImperativeHandle,useEffect, useState,useRef } from 'react';
import { Form,Modal} from "reactstrap";
import { Controller,useForm } from "react-hook-form";

import Swal from 'sweetalert2';
import API from '../../API';
import { TimeFormat,DateFormat, DateThai,DateFormatJSON,MobileFormat, NumberFormat,RootURL } from '../../Utils/Function';
import "react-datepicker/dist/react-datepicker.css";
import {RoleList,RoleName} from '../../Utils/Status';
const UserInfoCard = forwardRef((props,ref) =>{
    const { register, handleSubmit, watch, reset, getValues,setValue, control, formState: { errors } } = useForm();
    
    const [ModalState,setModalState] = useState(false);
    const [_Detail,setDetail] = useState(null);
    const [_Role,setRole] = useState(0);
    const [_StoreList,setStoreList] = useState([]);
    const [_Status,setStatus] = useState(null);
    const _ref = useRef();
    useEffect(() => {
        (async () => {
            _LoadStoreList();
        })();

        return ()=>{ }
    }, []);
    
    useImperativeHandle(ref, () => ({
        Show(UserID){
            setStoreList([]);
            setDetail(null);
            _LoadStoreList();
            if(UserID != null){
                _Load(UserID);
            }else{
                setValue("Name",null);
                setValue("Username",null);
                setValue("Role",0);
                setValue("StoreID",null);
                setValue("Remark",null);
                setValue('Password',null);
                setRole(0);
                setModalState(true);
            }
        },

    }));
    const _LoadStoreList = async()=>{
        setStoreList([]);
        API({method : "get",url:"/Admin/Store/List"}).then(res=>{
                if (res.status !== 200) {
                    return;
                }
    
                if (!res.data.Status) {
                    return;
                }
            setStoreList(res.data.Data);
        }).catch(res => {
                return;
        });
    }
    const _Load = async(UserID) =>{
        Swal.showLoading();
        API({method : "get",url:"/Admin/User/"+UserID}).then(res=>{
            Swal.close();
            if (!res.data.Status) {
                Swal.fire({
                    title: res.data.Message,
                    icon: 'error'
                });
                return;
            }
            const _MemberObj = res.data.Data;
            setDetail(res.data.Data);
            setValue("Name",_MemberObj.Name.trim());
            setValue("Username",_MemberObj.Username.trim());
            setValue("Role",_MemberObj.Role);
            setValue("StoreID",_MemberObj.StoreID);
            setValue("Remark",_MemberObj.Remark);
            setRole(_MemberObj.Role);
            setStatus(_MemberObj.Status);
            window.setTimeout(()=>{
                setModalState(true);
            },500);
            
        }).catch(res => {
            Swal.fire({
                title: res,
                icon: 'error'
            });
            return;
        });
    }
   
    const _UpdateStatus = async(method) => {
        if (_Detail == null) return;
        API({ method, url: '/Admin/User/' + _Detail.UserID + '/Status' }).then(res => {
            if (!res.data.Status) { Swal.fire({ icon: 'error', title: res.data.Message }); return; }
            setStatus(method === 'put' ? 1 : 2);
            if (props.update != undefined) {
                try { props.update(res.data.Data); } catch(e) { console.log(e); }
            }
        }).catch(() => { Swal.fire({ icon: 'error', title: 'การเชื่อมต่อผิดพลาด' }); });
    };

    const _Save = async()=>{
        if(getValues('Username') == undefined || getValues('Username') === ""){
            Swal.fire({
                icon: 'error',
                title: 'โปรดตรวจสอบ รหัสผู้ใช้งาน'
            });
            return;
        }
        if(getValues('Name') == undefined || getValues('Name') === ""){
            Swal.fire({
                icon: 'error',
                title: 'โปรดตรวจสอบ ชื่อ'
            });
            return;
        }
        let _reqObj = {
            UserID : (_Detail != null ? _Detail.UserID:null),
            Username: getValues('Username'),
            Name: getValues('Name'),
            Role: Number(getValues('Role')),
            StoreID:(getValues('StoreID') != null ? getValues('StoreID'):null),
            Remark: getValues('Remark'),
            Password : (getValues('Password') != null ? getValues('Password'):null)
        }
        Swal.fire({
            icon: 'warning',
            title: 'ต้องการบันทึก หรือไม่ ?',
            text : '',
            showCancelButton : true,
            confirmButtonText: 'บันทึก',
            confirmButtonColor:'#d33',
            cancelButtonText:'ยกเลิก'
        }).then((r)=>{
            if(!r.isConfirmed){
                return;
            }

            API({method : 'post',url:'/Admin/User/Save',data:_reqObj}).then(res=>{
                if(!res.data.Status){
                    Swal.fire({
                        icon: 'error',
                        title: res.data.Message
                    });
                    return;
                }
                setValue('Password',null);
                _Load(res.data.Data.UserID);
                Swal.fire({
                    icon: 'success',
                    title: 'บันทึกสำเร็จ',
                });
                //setModalState(false);
                //_ClearValuAction();
                if(props.update != undefined){
                    try{
                        props.update(res.data.Data);
                    }catch(e){
                        console.log(e);
                    }
                }
            }).catch(res => {
                if(res.response.data != undefined){
                    Swal.fire({
                        icon: 'error',
                        title: res.code,
                        text: res.response.data.Message
                    });
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'การเชื่อมต่อผิดพลาด',
                        text: res.message+' ['+res.code+']',
                    });
                }
            });
        });
    }

    return (
        <>
        <Modal isOpen={ModalState} className={'modal-xl'} centered={true} unmountOnClose={true}>
            <div className="modal-header">
                <h5 className="modal-title">ข้อมูลเจ้าหน้าที่ :: {(_Detail != null?_Detail.Name:"")}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"  onClick={()=>{setModalState(false)}}></button>
            </div>
            <div className='modal-body' style={{'minHeight':'500px'}}>
                <Form onSubmit={handleSubmit(_Save)} className='row g-3'>
                    <div className='row justify-content-center mt-2 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>รหัสผู้ใช้งาน</h3>
                        </div>
                        <div className='col-8'>
                            <input type='text' className='form-control' readOnly={(_Detail != null && _Detail.UserID != null ? true: false)}  {...register("Username", { required: true })} />
                        </div>
                    </div>
                    <div className='row justify-content-center mt-2 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>ชื่อ</h3>
                        </div>
                        <div className='col-8'>
                            <input type='text' className='form-control' {...register("Name", { required: true })} />
                        </div>
                    </div>
                    <div className='row justify-content-center mt-2 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>สิทธิ์</h3>
                        </div>
                        <div className='col-8'>
                            <Controller name="Role" control={control} rules={{required:false}} render={({field})=>(
                                <select className='form-control text-center' onChange={(e)=>{field.onChange(e);setRole(e.target.value);}} value={field.value} defaultValue={field.value} >
                                    <option value={0}>ไม่ระบุ</option>
                                    {RoleList.map((v,i)=>{
                                        return <option key={i} value={v}>{RoleName(v)}</option>
                                    })}
                                </select>
                            )} />
                        </div>
                    </div>
                    {(_Role == 2?
                        <>
                        <div className='row justify-content-center mt-2 mb-2'>
                            <div className='col-3 text-end mr-2'>
                                <h3>ร้านค้า</h3>
                            </div>
                            <div className='col-8'>
                                <Controller name="StoreID" control={control} rules={{required:false}} render={({field})=>(
                                    <select className='form-control text-center' onChange={(e)=>field.onChange(e)} value={field.value} defaultValue={field.value} >
                                        <option value={null} selected>ไม่ระบุ</option>
                                        {_StoreList.map((v,i)=>(
                                            <option key={i} value={v.StoreId}>{v.StoreCode} | {v.StoreName}</option>
                                        ))}
                                    </select>
                                )} />
                            </div>
                        </div>
                        </>
                    :"")}

                    <div className='row justify-content-center mt-2 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>รหัสผ่านใหม่</h3>
                        </div>
                        <div className='col-8'>
                            <input type='text' className='form-control' {...register("Password", { required: false })} />
                        </div>
                    </div>
                    <div className='row justify-content-center mt-5 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>หมายเหตุ</h3>
                        </div>
                        <div className='col-8'>
                            <Controller name="Remark" control={control} rules={{required:false}} render={({field})=>(
                                <textarea className="form-control" autoComplete="off"  onChange={(e)=>field.onChange(e)} defaultValue={field.value}/>
                            )} />
                        </div>
                    </div>
                    {_Detail != null && (
                        <div className='row justify-content-center mt-2 mb-2'>
                            <div className='col-3 text-end mr-2'>
                                <h3>สถานะ</h3>
                            </div>
                            <div className='col-8 d-flex align-items-center gap-3'>
                                <div className='form-check form-switch mb-0'>
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        role='switch'
                                        style={{ width: '3rem', height: '1.5rem', cursor: 'pointer' }}
                                        checked={_Status === 1}
                                        onChange={() => _UpdateStatus(_Status === 1 ? 'delete' : 'put')}
                                    />
                                </div>
                                <span className={`badge fs-6 ${_Status === 1 ? 'bg-success' : 'bg-danger'}`}>
                                    {_Status === 1 ? 'เปิดใช้งาน' : 'ปิดใช้งาน'}
                                </span>
                            </div>
                        </div>
                    )}
                    <div className='row mt-4'>
                        <div className='col-12'>
                            <div className='btn-group btn-group-lg float-end'>
                                <button type='submit' className='btn btn-success text-white'>บันทึกข้อมูล</button>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </Modal>
        </>)
        
});

export default React.memo(UserInfoCard)